import { render, staticRenderFns } from "./EditAttribute.vue?vue&type=template&id=02e12d40&"
import script from "./EditAttribute.vue?vue&type=script&lang=js&"
export * from "./EditAttribute.vue?vue&type=script&lang=js&"
import style0 from "./EditAttribute.vue?vue&type=style&index=0&id=02e12d40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports